// extracted by mini-css-extract-plugin
export default {"userIdentitiesContainer":"UserIdentities_userIdentitiesContainer__bsIjv","topButtons":"UserIdentities_topButtons__s3BHu"};